export default function mapElementToValue(mapName, valueSupplier) {
    const storage = {};

    if (!mapName) {
        mapName = 'mkey';
    }

    return {
        get(el) {
            let mapKey = $(el).data(mapName);
            if (!mapKey) {
                mapKey = mapName + '-' + new Date().getTime() + '-' + Math.random();
                $(el).data(mapName, mapKey);
            }

            let mapValue = storage[mapKey];
            if (!mapValue) {
                mapValue = valueSupplier(el);
                storage[mapKey] = mapValue;
            }

            return mapValue;
        }
    }
}